"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputComponent = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stylesUitlity = require("../../../../utils/stylesUitlity.js");
const _excluded = ["error", "errorColor", "success", "successColor", "defaultTextColor", "isFocus", "val", "valueTextAlign", "placeholder", "disabled", "disablebgColor", "fontSize", "textFontFamily", "textFontStyle", "textTransformation", "textFontWeight", "wordSpacing", "textDecoration", "letterSpacing", "lineHeight", "textShadow", "textIndent", "placeHolderColor", "placeholderFontFamily", "placeholderFontStyle", "placeholderFontSize", "placeholderFontWeight", "placeholderTextTransform", "placeholderTextDecoration", "placeholderLineHeight", "textPadding", "textMargin"];
const InputComponent = exports.InputComponent = _styledComponents.default.input`
	${_ref => {
  let {
      error,
      errorColor,
      success,
      successColor,
      defaultTextColor,
      isFocus,
      val,
      valueTextAlign = 'left',
      placeholder,
      fontSize = '12px',
      textFontFamily = 'Nunito Sans',
      textFontStyle,
      textTransformation,
      textFontWeight,
      wordSpacing,
      textDecoration,
      letterSpacing,
      lineHeight,
      textShadow,
      textIndent,
      placeHolderColor,
      placeholderFontFamily,
      placeholderFontStyle,
      placeholderFontSize,
      placeholderFontWeight,
      placeholderTextTransform,
      placeholderTextDecoration = 'none',
      placeholderLineHeight
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const showElement = isFocus || val?.length > 0 || placeholder;
  let color = defaultTextColor;
  if (error) {
    color = errorColor;
  } else if (success) {
    color = successColor;
  } else {
    color = defaultTextColor;
  }
  return `
			color: ${color};
			margin: 0;
			font-size: ${fontSize};
			line-height: ${lineHeight ? lineHeight : 16}px;
			width:inherit;
			${(0, _stylesUitlity.getTransition)(200, ['opacity', 'height', 'margin-top'], 'linear')}  
			opacity: ${showElement ? '1' : '0'};
			height: ${showElement ? 'auto' : '0px'};
			font-family: ${textFontFamily};
			font-style: ${textFontStyle};
			${wordSpacing ? `word-spacing:${wordSpacing}px` : ''};
  			text-indent:${textIndent}px;
  			text-align: ${valueTextAlign};

			${textTransformation ? `text-transform:${textTransformation}` : 'none'};
			${textDecoration ? `text-decoration:${textDecoration == 'strike_of' ? 'line-through' : textDecoration == 'underline_overline' ? 'underline overline' : textDecoration}` : 'none'};
			letter-spacing: ${letterSpacing}px;
			${textShadow ? `text-shadow:${textShadow}` : ''};
			font-weight: ${textFontWeight} !important;

			&::placeholder {
			  	${["underline_overline", "overline"].includes(placeholderTextDecoration) && `overflow: initial !important;`}
				font-weight: normal;
				color: ${placeHolderColor};
				font-family: ${placeholderFontFamily};
				font-style: ${placeholderFontStyle};
				font-size: ${placeholderFontSize}px;
				font-weight: ${placeholderFontWeight};
				text-transform: ${placeholderTextTransform};
				line-height: ${placeholderLineHeight};
				${placeholderTextDecoration ? `text-decoration:${placeholderTextDecoration == 'strike_of' ? 'line-through' : placeholderTextDecoration == 'underline_overline' ? 'underline overline' : placeholderTextDecoration}` : 'none'};
			}
		
			
		`;
}}
`;